import { paths } from '@/config/paths'
import { type EarnBackSource, getELendBackSource } from '@/features/elend/utils/getELendBackSource'
import type { YieldOpportunity } from '../types'

function appendFromParam(path: string, from: EarnBackSource = 'earn'): string {
  return path.includes('?') ? `${path}&from=${from}` : `${path}?from=${from}`
}

export function getYieldOpportunityDetailsPath(opportunity: YieldOpportunity): string {
  const { source, chainId, address, sourceData } = opportunity

  switch (source) {
    case 'evault':
      return appendFromParam(
        paths.lendDetails.replace(':chainId', chainId.toString()).replace(':vaultAddress', address),
      )

    case 'elend': {
      const basePath = paths.eLendDetails.replace(':chainId', chainId.toString()).replace(':vaultAddress', address)
      const from = getELendBackSource(opportunity.market?.key) ?? 'earn'

      if (sourceData.type === 'elend' && sourceData.subAccountId !== undefined) {
        return appendFromParam(`${basePath}?subAccountId=${sourceData.subAccountId}`, from)
      }
      return appendFromParam(basePath, from)
    }

    case 'isolated':
      return appendFromParam(
        paths.isolatedDetails.replace(':chainId', chainId.toString()).replace(':pairAddress', address),
        'isolated',
      )

    case 'pooled': {
      const token = opportunity.token
      if (!token) {
        return `${paths.earn}`
      }
      return appendFromParam(
        paths.pooledDetails.replace(':chainId', chainId.toString()).replace(':asset', token.address),
        'pooled',
      )
    }

    default:
      return paths.earn
  }
}
